export default __webpack_public_path__ + "static/media/central_andes_1_10.0a27c645.JPG";